import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import {
  EmailAccountContext,
  EmailAccountContextType,
} from "./EmailAccountContext";

export const useEmailAccount = (): EmailAccountContextType => {
  const context = useContext(EmailAccountContext);

  if (!context) {
    throw new HookOutOfContextError("useEmailAccount", "EmailAccountContext");
  }

  return context;
};
